import { usePortfolioStore } from "../../../state/portfolio";
import {
  MERCHANT_VAMP_ABOVE_STANDARD,
  MERCHANT_VAMP_EXCESSIVE,
} from "../../../data/acquirer";
import styles from "./Settings.module.css";

export function SettingsView() {
  const portfolio = usePortfolioStore((s) => s.portfolio);
  const acq = portfolio.acquirer;
  const internalCeiling = (acq.vampExcessive - acq.internalBufferBps / 100).toFixed(2);

  return (
    <div className={styles.wrap}>
      <Row label="acquirer">{acq.name}</Row>
      <Row label="scheme">visa · {acq.visaMember}</Row>
      <Row label="region">{acq.region}</Row>
      <Row label="bins">
        {acq.bins.map((b) => `${b.bin} ${b.ccy}`).join(" · ")}
      </Row>
      <div className={styles.divider} />
      <Row label="acquirer above standard">
        ≥ {acq.vampAboveStandard.toFixed(2)}% · ${acq.vampFeePerTxnUsd}/txn fee
      </Row>
      <Row label="acquirer excessive">
        ≥ {acq.vampExcessive.toFixed(2)}% · fee + enhanced monitoring
      </Row>
      <Row label="cb threshold">{acq.cbThreshold.toFixed(2)}%</Row>
      <Row label="internal buffer">{acq.internalBufferBps} bps</Row>
      <Row label="internal ceiling">{internalCeiling}%</Row>
      <div className={styles.divider} />
      <Row label="merchant above standard">
        ≥ {MERCHANT_VAMP_ABOVE_STANDARD.toFixed(2)}% (jan 2026+)
      </Row>
      <Row label="merchant excessive">
        ≥ {MERCHANT_VAMP_EXCESSIVE.toFixed(2)}% (apr 2026+, us/ca/eu)
      </Row>
      <div className={styles.divider} />
      <Row label="portfolio">{portfolio.merchants.length} merchants</Row>
      <Row label="tc40 records">{portfolio.tc40.length}</Row>
      <Row label="ethoca alerts">{portfolio.ethoca.length}</Row>
      <Row label="evidence packages">{portfolio.evidence.length}</Row>
    </div>
  );
}

function Row({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div className={styles.row}>
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>{children}</span>
    </div>
  );
}
